import { create } from 'zustand';

export const useActivityLogStore = create((set, get) => ({
  logs: [],
  maxLogs: 500,

  addLog: (action, details = {}) => {
    const entry = {
      id: Date.now() + '-' + Math.random().toString(36).slice(2, 6),
      timestamp: new Date().toISOString(),
      action,
      details
    };
    set((state) => ({
      logs: [entry, ...state.logs].slice(0, state.maxLogs)
    }));
  },

  clearLogs: () => set({ logs: [] }),

  // Convenience methods
  logProductAdded: (product) => {
    get().addLog('PRODUCT_ADDED', {
      title: product.title,
      variant: product.variantTitle || '',
      sku: product.sku || '',
      price: product.price,
      quantity: product.quantity || 1,
      locationType: product.locationType || '',
      locationName: product.locationName || ''
    });
  },

  logProductRemoved: (product) => {
    get().addLog('PRODUCT_REMOVED', {
      title: product.title,
      variant: product.variantTitle || '',
      sku: product.sku || ''
    });
  },

  logQuantityUpdated: (product, oldQty, newQty) => {
    get().addLog('QUANTITY_UPDATED', {
      title: product.title,
      variant: product.variantTitle || '',
      oldQty,
      newQty
    });
  },

  logDiscountApplied: (code, amount) => {
    get().addLog('DISCOUNT_APPLIED', { code, amount });
  },

  logDiscountRemoved: (code) => {
    get().addLog('DISCOUNT_REMOVED', { code });
  },

  logGiftCardApplied: (code, balance) => {
    get().addLog('GIFT_CARD_APPLIED', { code: code.slice(-4), balance });
  },

  logGiftCardRemoved: (code) => {
    get().addLog('GIFT_CARD_REMOVED', { code: code.slice(-4) });
  },

  logCartCleared: () => {
    get().addLog('CART_CLEARED', {});
  },

  logOrderPlaced: (orderName, total, paymentMethod, fulfillmentSource) => {
    get().addLog('ORDER_PLACED', { orderName, total, paymentMethod, fulfillmentSource: fulfillmentSource || '' });
  },

  logCustomerSelected: (name, phone) => {
    get().addLog('CUSTOMER_SELECTED', { name, phone });
  },

  logCustomerRemoved: () => {
    get().addLog('CUSTOMER_REMOVED', {});
  },

  logPaymentInitiated: (method, amount, refNumber) => {
    get().addLog('PAYMENT_INITIATED', { method, amount, refNumber: refNumber || '' });
  },

  logPaymentSuccess: (method, txnId, refNumber) => {
    get().addLog('PAYMENT_SUCCESS', { method, txnId, refNumber: refNumber || '' });
  },

  logPaymentFailed: (method, error, refNumber) => {
    get().addLog('PAYMENT_FAILED', { method, error, refNumber: refNumber || '' });
  },

  logPaymentTimeout: (method, amount, refNumber) => {
    get().addLog('PAYMENT_TIMEOUT', { method, amount, refNumber: refNumber || '' });
  },

  logPaymentCancelled: (method, amount, refNumber) => {
    get().addLog('PAYMENT_CANCELLED', { method, amount, refNumber: refNumber || '' });
  },

  logLogin: (username, storeName) => {
    get().addLog('LOGIN', { username, storeName });
  },

  logLogout: () => {
    get().addLog('LOGOUT', {});
  }
}));
